import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=3617a83f&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "../../css/tag.css?vue&type=style&index=0&id=3617a83f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617a83f",
  null
  
)

export default component.exports